import { formatDateForDisplay } from "../../../../../utils/date/DateUtils";

export const ALL_TRANSACTION_PARAMS = { mode: "all" };

export const LATEST_TRANSACTION_PARAMS = { mode: "limit", limit: 6 };

export const DEFAULT_TRANSACTION_DATE_FILTER = "1m";

export const TRANSACTION_DATE_FILTERS = [
  { labelKey: "today", value: "today" },
  { labelKey: "one_week", value: "1w" },
  { labelKey: "one_month", value: "1m" },
  { labelKey: "one_year", value: "1y" },
  { labelKey: "custom", value: "custom" },
];

export const formatDateParam = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getDateRangeParams = (dateFilter) => {
  const endDate = new Date();
  const startDate = new Date(endDate);

  if (dateFilter === "today") {
    return {
      start_date: formatDateParam(startDate),
      end_date: formatDateParam(endDate),
    };
  }

  if (dateFilter === "1w") {
    startDate.setDate(startDate.getDate() - 7);
  } else if (dateFilter === "1m") {
    startDate.setMonth(startDate.getMonth() - 1);
  } else if (dateFilter === "1y") {
    startDate.setFullYear(startDate.getFullYear() - 1);
  }

  return {
    start_date: formatDateParam(startDate),
    end_date: formatDateParam(endDate),
  };
};

export const isCustomDateRangeValid = (fromDate, toDate, validationCopy) =>
  validateCustomDateRange(fromDate, toDate, validationCopy) === "";

export const formatCustomDateRangeLabel = (customRange, customLabel) => {
  if (!customRange?.start_date || !customRange?.end_date) {
    return customLabel;
  }

  const from = formatDateForDisplay(customRange.start_date);
  const to = formatDateForDisplay(customRange.end_date);

  return `${from} - ${to}`;
};

export const getDateFilterLabel = (
  filter,
  appliedDateFilter,
  customRange,
  dateFilterCopy,
) => {
  if (
    filter.value === "custom" &&
    appliedDateFilter === "custom" &&
    customRange?.start_date &&
    customRange?.end_date
  ) {
    return formatCustomDateRangeLabel(customRange, dateFilterCopy?.custom);
  }

  return dateFilterCopy?.[filter.labelKey] || filter.value;
};

export const isDateFilterActive = (
  filterValue,
  appliedDateFilter,
  isCustomDateModalOpen,
) => {
  if (filterValue === "custom") {
    return isCustomDateModalOpen || appliedDateFilter === "custom";
  }

  return !isCustomDateModalOpen && appliedDateFilter === filterValue;
};

export const validateCustomDateRange = (fromDate, toDate, validationCopy) => {
  if (!fromDate || !toDate) {
    return validationCopy?.both_dates_required || "";
  }

  const from = new Date(`${fromDate}T00:00:00`);
  const to = new Date(`${toDate}T00:00:00`);

  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
    return validationCopy?.invalid_dates || "";
  }

  if (from > to) {
    return validationCopy?.invalid_order || "";
  }

  return "";
};

export const buildTransactionRequestParams = (
  dateFilter,
  customRange = null,
) => {
  if (dateFilter === "custom") {
    return {
      ...ALL_TRANSACTION_PARAMS,
      start_date: customRange.start_date,
      end_date: customRange.end_date,
    };
  }

  return {
    ...ALL_TRANSACTION_PARAMS,
    ...getDateRangeParams(dateFilter),
  };
};

export const getTransactionRequestParams = (dateFilter, customRange = null) => {
  if (dateFilter === "custom") {
    if (!customRange?.start_date || !customRange?.end_date) {
      return buildTransactionRequestParams(DEFAULT_TRANSACTION_DATE_FILTER);
    }

    return buildTransactionRequestParams("custom", customRange);
  }

  return buildTransactionRequestParams(dateFilter);
};
